import {
    connectionReducerType,
    CONNECTION_LIST_SEARCH_TERM,
    SET_CONNECTION_ID,
    SET_CONNECTION_LIST_PAGE,
} from '../actions/types/connection.actions.types';

export interface ConnectionReducerState {
    connectionId: string;
    connectionListPage: number;
    connectionListSearchTerm: string;
}

export const preloadedState: ConnectionReducerState = {
    connectionId: '',
    connectionListPage: 1,
    connectionListSearchTerm: '',
};

export const connectionReducer = (
    state: ConnectionReducerState = preloadedState,
    action: connectionReducerType
): ConnectionReducerState => {
    switch (action.type) {
        case SET_CONNECTION_ID:
            return {...state, connectionId: action.connectionId};
        case SET_CONNECTION_LIST_PAGE:
            return {...state, connectionListPage: action.payload};
        case CONNECTION_LIST_SEARCH_TERM:
            return {...state, connectionListSearchTerm: action.searchTerm};
        default:
            return {...state};
    }
};
